import React from "react";
import { dateConversion } from "../../utils/formatDate";
import "./Carcard.styles.css";
import { FaExclamationCircle } from "react-icons/fa";
import CarStatus from "../CarStatus/CarStatus";

interface CarCardProps {
  action: string;
  revertedDraft: string;
  grade: string;
  issueDate: string;
  dueDate: string;
  onClick: () => void;
  closedDate:string
  name: string;
}

const gradeColors: { [key: string]: string } = {
  "Major": "#C43131",
  "Minor": "#F49632",
  Observation: "#919191",
};

const grades: { [key: string]: string } = {
  "Major": "Major CAR",
  "Minor": "Minor CAR",
  Observation: "Observation",
};

const CarCard: React.FC<CarCardProps> = ({
  action,
  revertedDraft,
  grade,
  issueDate,
  dueDate,
  onClick,
  closedDate,
  name
}) => {
  const cardColor = gradeColors[grade];
  const OpenCarColor = action === "Closed" ? "#919191" :""
  const carDueDate = action === "Closed" ? closedDate : dueDate;  
  return (
    <div
      className="card car-card-custom"
      style={{ borderLeftColor: OpenCarColor ? "#EDEDED" :cardColor }}
      onClick={onClick}
    >
      <div className="card-body">
        <div className="row">
          <div className="col p-0">
             <CarStatus status={action} revertedDraft={revertedDraft}/>
            <p className="card-id m-0" style={{color : OpenCarColor ? OpenCarColor : "" }}>{name}</p>
          </div>
          <div className="col p-0">
            <p className="card-grade m-0" style={{color : OpenCarColor ? OpenCarColor : "" }}>
              Grade:{" "}
              <span style={{ color: OpenCarColor ? OpenCarColor : cardColor, fontWeight: "500" }}>
                {grades[grade]}
              </span>
            </p>
            <p className="card-grade m-0" style={{color : OpenCarColor ? OpenCarColor : "" }}>
              Issue date: <span style={{ fontWeight: "300" }}>{issueDate ? dateConversion(issueDate, "DD MMMM YYYY") : "--"}</span>
            </p>
            <p className="card-grade m-0" style={{color : OpenCarColor ? OpenCarColor : "" }}>
              {action === "Closed" ? "Closed" : 'Due'} date: <span style={{ fontWeight: "300" }}>{carDueDate? dateConversion(carDueDate, "DD MMMM YYYY") : "--"}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarCard;
